var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 33,
    viewBox: "0 0 27 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.5C14.3938 16.5 15.1591 16.1815 15.7961 15.5445C16.432 14.9086 16.75 14.1438 16.75 13.25C16.75 12.3562 16.432 11.5909 15.7961 10.9539C15.1591 10.318 14.3938 10 13.5 10C12.6062 10 11.8414 10.318 11.2055 10.9539C10.5685 11.5909 10.25 12.3562 10.25 13.25C10.25 14.1438 10.5685 14.9086 11.2055 15.5445C11.8414 16.1815 12.6062 16.5 13.5 16.5ZM13.5 32.75C9.13958 29.0396 5.88308 25.593 3.7305 22.4101C1.57683 19.2284 0.5 16.2833 0.5 13.575C0.5 9.5125 1.80704 6.27604 4.42113 3.86562C7.03413 1.45521 10.0604 0.25 13.5 0.25C16.9396 0.25 19.9659 1.45521 22.5789 3.86562C25.193 6.27604 26.5 9.5125 26.5 13.575C26.5 16.2833 25.4237 19.2284 23.2711 22.4101C21.1175 25.593 17.8604 29.0396 13.5 32.75Z",
    fill: "#113E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLocation);
export default __webpack_public_path__ + "static/media/contactLocation.4606d4111be8474736d64e559e2e40ab.svg";
export { ForwardRef as ReactComponent };